//rafce
import React, {useState,useEffect,useRef,useMemo} from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { Link, useNavigate } from "react-router-dom";
import Dialog from "../Dialog";
import MaterialReactTable from 'material-react-table';
import SideBar from "../sidebar/Sidebar";
import RiseLoader from "react-spinners/RiseLoader";

//DONT DELETE!!
// Sourch Code reference from : https://www.telerik.com/kendo-react-ui/components/excelexport/
//                    https://www.npmjs.com/package/material-react-table
const styleTittle = {

  fontSize: 20,
  color: "#4a54f1",
  textAlign: "center",
  paddingBottom: "20px",
  paddingTop: "5px",

}
const stylespinner = {
  position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
}

const Kategori = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    refreshToken();
    getKategori();
    
},[]);// eslint-disable-line react-hooks/exhaustive-deps

    const [kategori,setKategori] = useState([]);
    const [token, setToken] = useState("");
    const [expire, setExpire] = useState("");
    const navigate = useNavigate();

// START ---TOKEN--- 
const refreshToken = async() => {
  try {
        const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setExpire(decoded.exp);
        if (decoded.role==='admin') {
            navigate("/")
        }

  } catch (error) {
      if(error.response){
        navigate("/login");
      }
  }
}

const axiosJWT = axios.create();

axiosJWT.interceptors.request.use(async(config) => {
    const curretDate = new Date();
    if(expire * 1000 < curretDate.getTime()){
        const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setExpire(decoded.exp);
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// ----END---

const getKategori = async () => {
    const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/kategori`,{
        headers:{
            Authorization:`Bearer ${token}`
        }
    });
    // console.log("ini hasil get",response.data[0]);
    setKategori(response.data[0]);
    setLoading(false);
}

//DELETE
const idKategoriRef = useRef();
const [dialog, setDialog] = useState({
    message:"",
    isLoading:false,
    namaKategori:""
});

const handleDialog = (message, isLoading, jenisKategori)=> {
    setDialog({
        message,
        isLoading,
        jenisKategori
    });
};

const handleDelete = (kodeKategori,jenisKategori) => {
    handleDialog("Yakin Ingin Hapus?",true,jenisKategori);
    idKategoriRef.current = kodeKategori;
};

const areUSureDelete = (choose) => {
    if (choose) {
      deletekategori(idKategoriRef.current);   
      handleDialog("", false);
    } else {
      handleDialog("", false);
    }
  };

const deletekategori = async (kodeKategori) =>{
    try {
        await axios.delete(`${process.env.REACT_APP_MASTER_URL}/kategori/${kodeKategori}`);
        getKategori();
    } catch (error) {
        console.log(error);
        
    }
}
  //Table
  const columns = useMemo(
    () => [
      {
        accessorKey: "jenisKategori", //simple recommended way to define a column
        header: "Jenis Kategori",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "createdAt", //simple recommended way to define a column
        header: "tgl buat",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "#", //simple recommended way to define a column
        header: "Aksi",
        muiTableHeadCellProps: { sx: { color: "red" } },
         //custom props
        Cell: ( props ) => ( <>  <a> <button
                                                onClick={() => handleDelete(props.row.original.kodeKategori,props.row.original.jenisKategori )}
                                                className="button is-small is-danger">
                                                Delete 
                                              </button>
                                          </a> 
                                 
                            </>
                            ),
      },
    ],
    []
  ); 

  
  return (
    <div>
      {loading ?
        <div style={stylespinner}>
          <RiseLoader
            color={'#301E67'}
            loading={loading}
            size={20}
            hidden={100}
            textAlign='centered'
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div> 
          :
    <SideBar>
    <div className="columnms mt-5 is centered">
        <img src={`${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`}  alt="Not Found" width={300} height={300}></img>
        <div className="column is-half"></div>
            <label className='label' style={styleTittle}><center>KATEGORI LIST</center></label>
            <Link to={'tambahkategori'} className="button is-link">Tambah Kategori</Link>
                    <MaterialReactTable 
                        enableRowNumbers
                        rowNumberMode="static"
                        columns={columns} data={kategori} 
                        // enableStickyHeader
                        enableStickyFooter
                        // muiTableProps={{
                        //   sx: {
                        //     tableLayout: 'fixed',
                        //   },
                        // }}
                        defaultColumn={{
                          minSize: 10, //allow columns to get smaller than default
                          maxSize: 260, //allow columns to get larger than default
                          size: 260, //make columns wider by default
                        }}
                      />
            {dialog.isLoading && (
                <Dialog
                //Update
                nameProduct={dialog.jenisKategori}
                onDialog={areUSureDelete}
                message={dialog.message}
                />
                )}

    </div>
    </SideBar>
     }
     </div>
  )
}

export default Kategori